import React, { useState, useEffect, useRef } from 'react';
import './Preloader.css';
import {
    startBackgroundSound,
} from '../../utils/soundUtils';

const Preloader = ({ active, onStart }) => {
    const [show, setShow] = useState(true);

    const [showButton, setShowButton] = useState(false);
    const timerRef = useRef(null);

    const buttonTimerRef = useRef(null);

    useEffect(() => {
        // Show button after 2 seconds
        buttonTimerRef.current = setTimeout(() => {
            setShowButton(true);
        }, 2000);

        return () => {
            // Cleanup timers
            clearTimeout(buttonTimerRef.current);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    const handleStartClick = () => {
        startBackgroundSound();
        setShow(false);
        if (onStart) {
            onStart();
        }
    };

    // Only show the preloader if either:
    // 1. We're still in the active state, or
    // 2. We're in the 5-second timeout after active became false
    const isVisible = active || show;

    return (
        <div className={`preloader-overlay ${isVisible ? 'visible' : ''}`}>
            <img src="assets/images/CR-Logo.gif" alt="Crafted Reality Icon" />
            <div className="loader-container">

                {showButton ? (
                    <button className="start-button" onClick={handleStartClick}>
                        Showtime!
                    </button>
                ) : (
                    /* <div className="spinner"></div> */
                    <div className="loader">
                        <div className="saw-container">
                            <img src="assets/images/Preloader_Icon_Sägeblatt.svg" alt="Sägeblatt" className="sawblade" />
                            <div className="table-line"></div>
                        </div>
                        <p className="text">
                            Crafting<span className="dots">
                                <span className="dot dot1">.</span>
                                <span className="dot dot2">.</span>
                                <span className="dot dot3">.</span>
                            </span>
                        </p>
                    </div>

                )}
            </div>
        </div>
    );
};

export default Preloader;